import type React from "react";
import { useTranslation } from "react-i18next";
import FinancialSummaryCards from "../common/FinancialSummaryCards";
import { TestId } from "../../constants/testIds";
import type translations from "../../translations/translations.json";
import { isReportApproved, type UangJalanReportStatus } from "../../types/uangJalanReport";

type TranslationKeys = keyof typeof translations.en;

interface ReportSummaryCardsProps {
  totalPaid: number;
  totalApproved: number;
  difference: number;
  status: UangJalanReportStatus;
}

const ReportSummaryCards: React.FC<ReportSummaryCardsProps> = ({
  totalPaid,
  totalApproved,
  difference,
  status,
}) => {
  const { t } = useTranslation();
  const approved = isReportApproved(status);
  const pendingLabel = t("reports.pending" as TranslationKeys);

  return (
    <FinancialSummaryCards
      totalPaid={totalPaid}
      totalVerified={totalApproved}
      difference={difference}
      totalPaidLabel={t("reports.totalPaid" as TranslationKeys)}
      totalVerifiedLabel={t("reports.totalApproved" as TranslationKeys)}
      differenceLabel={t("reports.difference" as TranslationKeys)}
      totalPaidTestId={TestId.UJR.TOTAL_PAID}
      totalVerifiedTestId={TestId.UJR.TOTAL_APPROVED}
      differenceTestId={TestId.UJR.DIFFERENCE}
      totalVerifiedDisplay={approved ? undefined : pendingLabel}
      differenceDisplay={approved ? undefined : pendingLabel}
    />
  );
};

export default ReportSummaryCards;
